// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2040": "58703928","2980": "cb5bfe21","3859": "14a27f2f","5545": "20927b2f","8773": "778523c8",}[chunkId] + ".css"
}